<template>
  <div>
    <div class="text-center mb-20 glot-text-color-EB font-hairline">
      <span class="text-center" v-html="$t('RegisterHead')"></span><b class="ml-1">{{email}}</b>
    </div>
    <form
      @submit.prevent="validForm('registerForm')"
      data-vv-scope="registerForm"
    >
      <vs-input
        v-validate="
          'required|min:3|max:20'
        "
        data-vv-validate-on="input"
        name="displayName"
        icon-no-border
        :label-placeholder="$t('DisplayName')"
        v-model="name"
        class="w-full"
      />


      <div class="relative">
        <vs-input
          data-vv-validate-on="input"
          v-validate="'required|min:6'"
          :type="passwordType"
          name="password"
          icon-no-border
          :label-placeholder="$t('YourPassWord')"
          v-model="password"
          class="w-full mb-1"
        />
        <span
          class="absolute m-auto top-0 bottom-0 right-0 mr-1 flex items-center cursor-pointer"
        >
          <feather-icon
            :icon="[passwordIcon]"
            @click="hidePassword = !hidePassword"
            svgClasses="h-4 w-4 stroke-current text-grey absolute m-auto top-0 bottom-0 right-0 mr-1"
            class="block"
          />
        </span>
      </div>
      <div class="text-danger text-sm">
        {{ errors.first("registerForm.password") }}
      </div>
      <input class="opacity-0 absolute" type="submit" />
    </form>

    <div class="mt-10">
      <vs-button
        :disabled="!validateForm"
        class="w-full glot-background-color-1D uppercase"
        @click="validForm('registerForm')"
        >{{ $t("CreateAcc") }}</vs-button
      >
    </div>

    <div class="text-center glot-text-color-C2 font-light mt-6">
              {{$t('EmailSupportEmail')}}
              <div>
                <b>{{$t('GlotSupportEmail')}}</b>
              </div>
     </div>
  </div>
</template>

<script>
import _throttle from 'lodash/throttle'

import { getErrorMessage } from '@/i18n/util'


export default {
  components: {},
  data () {
    return {
      email: '',
      password: '',
      name: '',
      hidePassword: true,
      hash: ''
    }
  },
  created () {
    const token = this.$route.query.token
    if (token) {
      const strDecode = atob(token)
      const [hash, email] = strDecode.split('::')
      this.hash = hash
      this.email = email
    }
   
    if (!this.email || !this.hash) {
      this.$router.push('/register')
    }
  },
  computed: {
    validateForm () {
      return (
        !this.errors.any() &&
        this.email !== '' &&
        this.password !== ''
      )
    },
    passwordType () {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon () {
      return this.hidePassword ? 'EyeIcon' : 'EyeOffIcon'
    }
  },
  methods: {
    err (msg) {
      if (typeof console !== 'undefined') {
        console.error(`[vue-apple-signin] ${msg}`)
      }
    },
    clickSignUp: _throttle(function (vm) {
      if (!vm.checkLogin()) return
      vm.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })
      const ref = localStorage.getItem('referal')
      const payload = {
        displayName: vm.name,
        email: vm.email,
        password: vm.password,
        hash: vm.hash
      }
      if (ref) {
        payload.ref = ref
      }
      vm.$store
        .dispatch('auth/registerUserWithEmail', payload)
        .then(res => {
          vm.$vs.loading.close()
          vm.$vs.notify({
            title: 'Login Success',
            text: 'Login Success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
       
          if (!res.needVerify) {
            vm.$router.push(`/login-success?token=${res.jwt}`)
          } 
        })
        .catch((err) => {
          vm.$vs.loading.close()
          err.messages.map((e) => {
            let type = 'name'
            if (e.id === 'Auth.form.error.email.taken') {
              type = 'email'
            }
            vm.errors.add({
              field: type,
              msg: getErrorMessage([e]),
              scope: 'registerForm'
            })
          })
          vm.$vs.notify({
            title: 'Register Attempt',
            text: getErrorMessage(err.messages),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            fixed: true
          })
        })
    }),
    validForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.clickSignUp(this);
        }
      })
    },
    checkLogin () {
      // If user is already logged in notify
      return true
    }
  },
  beforeDestroy () {
    const self = this
    document.removeEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.removeEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  },
  mounted () {
    if (!window.AppleID) {
      this.err(
        '"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" needs to be included as a <script>'
      )
      return
    }
    const clientId = this.clientId
    const scope = this.scope
    const redirectURI = this.redirectURI
    const state = this.state
    const nonce = this.nonce
    const usePopup = this.usePopup === 'true'

    if (!clientId) {
      this.err('options.clientId must be specified.')
      return
    }

    if (!redirectURI) {
      this.err('options.redirectURI must be specified.')
      return
    }

    if (!state) {
      this.err('options.state must be specified.')
      return
    }

    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup,
      nonce
    })
    const self = this
    document.addEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.addEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
